import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { SuccessIcon, ErrorIcon } from "./Icons/Notifications";
import Theme from "../UI/Theme";
import { rem } from "polished";

const StyledNotification = styled.div`
  padding: ${rem("24px")};
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHeaderText = styled.div`
  font-family: ${({ theme }) => theme.secondaryFont};
  ${({ theme }) => theme.ADAFont("16px")};
  font-weight: 500;
  color: #343638;
  margin-left: ${rem("12px")};
`;

const StyledBody = styled.div`
  font-family: ${({ theme }) => theme.secondaryFont};
  ${({ theme }) => theme.FontWithLineHeight("14px")}
  font-weight: 400;
  color: #666666;
  margin-top: ${rem("8px")};
`;

const Notification = ({ header, body, type }) => {
  let icon = <ErrorIcon />;
  switch (type) {
    case "success":
      icon = <SuccessIcon />;
      break;
    default:
      icon = <ErrorIcon />;
  }

  return (
    <Theme>
      <StyledNotification header={header} body={body}>
        <StyledHeader>
          {icon}
          <StyledHeaderText>{header}</StyledHeaderText>
        </StyledHeader>
        {body && <StyledBody>{body}</StyledBody>}
      </StyledNotification>
    </Theme>
  );
};

Notification.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string,
  // Specify the type of notification: success, error, warn, info
  type: PropTypes.string,
};

export default Notification;
